// extracted by mini-css-extract-plugin
export default {"yellowblink":"RdvAttendancePanel_yellowblink__LlIUG","yellow-blinker":"RdvAttendancePanel_yellow-blinker__K3hi3"};